import { render, staticRenderFns } from "./PriceComponent.vue?vue&type=template&id=92bb8914&scoped=true"
import script from "./PriceComponent.vue?vue&type=script&lang=js"
export * from "./PriceComponent.vue?vue&type=script&lang=js"
import style0 from "./PriceComponent.vue?vue&type=style&index=0&id=92bb8914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bb8914",
  null
  
)

export default component.exports